import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import './ViewChoicesTab.css';


function ViewChoicesTab(props)
{
  const auditionees = props.additional.auditionees;
  const clashBotData = props.additional.clashBotData;
  const register = props.additional.register;

  const setSelected = props.additional.setSelected;

  const header = ['Role', '1', '2', '3', '4', '5'];

  if(auditionees.length === 0) {
    return (
      <SubTabNoData 
        icon={faExclamation} 
        title='No Auditionees' 
        description="No auditionees to display"
      />
    )
  }

  let choicesDisplay = clashBotData.map((project) => {
    
    const body = _parseToTable(project.roles, register, auditionees, setSelected);
    return (
      <div key={project.uid}>
        <SubTabTable title={project.name} description={'Week ' + project.week + ' ' + project.project_type} header={header} body={body} numbered />
      </div>
    )
  })

  return (
    <SubTabParent passData={props}>
      {choicesDisplay}
    </SubTabParent>
  )
}


export default ViewChoicesTab;




const _parseToTable = (roles, register, auditionees, setSelected) => {

  const body = roles.map((role, i) => {
    const choices = role.choices;

    const cast = role.cast;
    var isClash = false;
    var isPotentialClash = false;
    var isGhostClash = false;

    register.every((x) => {
      if(x.auditionee_id === role.choices[0] && x.current_choices.length > 1) {
        isClash = true;
        register.every((y) => {
          if(y.auditionee_id === role.choices[1]) { 
            isPotentialClash = y.potential_clash; 
            return false 
          }
          return true;
        })
        return false;
      }
      else if(x.auditionee_id === role.choices[0] && x.current_choices.length == 1) {
        isPotentialClash = x.potential_clash;
        register.every((y) => {
          if(y.auditionee_id === role.choices[1]) { 
            isGhostClash = y.ghost_clash; 
            return false 
          }
          return true;
        })
      }
      return true;
    })

    const outOfOptions = (role.choices[0] === null);

    function parseChoice(x, i) {
      if(x === '' || x === null) return '';
      const name = auditionees[x].names[0];
      if(outOfOptions)                                    return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#57606f', cursor: 'pointer'}}>{name}</div>)
      else if(cast === true)                              return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#6ab04c', cursor: 'pointer'}}>{name}</div>)
      else if(isClash && i === 0)                         return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#d63031', cursor: 'pointer'}}>{name}</div>)
      else if(isPotentialClash && isClash && i == 1)      return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#f0932b', cursor: 'pointer'}}>{name}</div>)
      else if(isPotentialClash && i == 0)                 return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#f0932b', cursor: 'pointer'}}>{name}</div>)
      // else if(isPotentialClash && isGhostClash && i == 1) return (<div onClick={() => setSelected(x)} style={{color: '#f6e58d', cursor: 'pointer'}}>{name}</div>)
      else if(isGhostClash && i == 1)                     return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#22a6b3', cursor: 'pointer'}}>{name}</div>)
      else                                                return (<div className='name-cell' onClick={() => setSelected(x)} style={{color: '#c0c0c0', cursor: 'pointer'}}>{name}</div>)
    }

    function parseName(x) {
      if(outOfOptions)                    return (<b style={{color: '#57606f'}}>{x}</b>)
      else if(cast === true)              return (<b style={{color: '#6ab04c'}}>{x}</b>)
      else                                return (<b>{x}</b>)
    }

    return (
      [
        parseName(role.name),
        parseChoice(choices[0], 0),
        parseChoice(choices[1], 1),
        parseChoice(choices[2], 2),
        parseChoice(choices[3], 3),
        parseChoice(choices[4], 4),
      ]
    )
  })

  return body;

}